import React, { useState } from 'react';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import BobModal from '../../../components/BobModal';

import * as K2aCoreActions from '../../../actions/k2aCoreActions';

import * as classes from './AddNewEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required()
});

const AddNewAreaModal = ({
    client,
    createCoreArea,
    site,
    setIsAddNewAreaModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const body = {
                siteId: site.id,
                name:   values.name
            };

            try {
                setIsLoading(true);
                const isCreated = await createCoreArea(site.id, body);
                setIsLoading(false);
                if (isCreated) setIsAddNewAreaModalOpen(false);
            } catch (error) {
                setIsLoading(false);
            }
        }
    });

    return (
        <BobModal
            title={'Add New Area'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setIsAddNewAreaModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.Row}>
                    <div className={classes.Label}>
                        Client
                    </div>
                    <div className={classes.Value}>
                        {client.name}
                    </div>
                </div>
                <div className={classes.BottomRow}>
                    <div className={classes.Label}>
                        Site
                    </div>
                    <div className={classes.Value}>
                        {site.name}
                    </div>
                </div>
                <FormControl className={classes.Row}>
                    <TextField
                        className={classes.Input}
                        id="name"
                        name="name"
                        type="text"
                        value={formik.values.name}
                        label={<span>New Area Name<span className={classes.required}> *</span></span>}
                        placeholder="Enter"
                        size="small"
                        onChange={formik.handleChange}
                        InputProps={{
                            onBlur: formik.handleBlur
                        }}
                        variant="outlined"
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                        error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                        helperText={Boolean(formik.touched.name) && formik.errors.name}
                    />
                </FormControl>
                <div className={classes.ButtonContainer}>
                    <BobCancelButton
                        className={classes.CancelButton}
                        disabled={isLoading}
                        onClick={() => setIsAddNewAreaModalOpen(false)}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        onClick={formik.handleSubmit}
                        label={'Create'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapDispatchToProps = {
    ...K2aCoreActions
};

export default connect(null, mapDispatchToProps)(AddNewAreaModal);
